'use client'

import { useEffect, useState } from 'react'

export const isMarketplaceEnabled = process.env.NEXT_PUBLIC_MARKETPLACE_ENABLED === 'true'

export function useIsMarketplaceEnabled() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return mounted ? isMarketplaceEnabled : false
}
